<mat-expansion-panel *ngIf="isCollapse; else noCollapse" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span>
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template *ngTemplateOutlet="fontConfig"></ng-template>
</mat-expansion-panel>

<mat-divider *ngIf="isCollapse"></mat-divider>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<ng-template #noCollapse>
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <ng-template *ngTemplateOutlet="fontConfig"></ng-template>
</ng-template>

<ng-template #fontConfig>
  <div class="top-block">
    <div class="select-container">
      <q9-select
        [ngModel]="styleObj.font"
        (ngModelChange)="handleSwitchFont('font', $event)"
        class="font-select">
        <q9-option *ngFor="let font of fonts" [value]="font">{{ font }}</q9-option>
      </q9-select>

      <q9-select
        [ngModel]="styleObj.fontSize"
        (ngModelChange)="handleSwitchFont('fontSize', $event)"
        class="size-select">
        <q9-option *ngFor="let size of fontSizes" [value]="size">{{ size }}</q9-option>
      </q9-select>
    </div>
    <div class="first-block">
      <div class="block__color">
        <app-full-color-picker
          class="block__color--picker"
          [(value)]="styleObj.fontColor"
          (picked)="throwUp($event)"></app-full-color-picker>
        <span class="block__color--label">{{ 'ASIDE_R.FONT_COLOR' | translate }}</span>
      </div>

      <mat-divider [vertical]="true"></mat-divider>

      <div class="format-buttons" [ngClass]="{'format-buttons__grid': controlsMode === 3}">
        <q9-icon-button
          [ngClass]="{enabled: styleObj.fontBold || (buttonsEnabled && buttonsEnabled.bold)}"
          (click)="handleSwitchFont('fontBold', !styleObj.fontBold)"
          icon="action_icons:edit_bold"></q9-icon-button>

        <q9-icon-button
          [ngClass]="{enabled: styleObj.fontItalic || (buttonsEnabled && buttonsEnabled.italic)}"
          (click)="handleSwitchFont('fontItalic', !styleObj.fontItalic)"
          icon="action_icons:edit_italic"></q9-icon-button>

        <q9-icon-button
          [ngClass]="{
            enabled: styleObj.fontUnderline || (buttonsEnabled && buttonsEnabled.underline)
          }"
          (click)="handleSwitchFont('fontUnderline', !styleObj.fontUnderline)"
          icon="action_icons:edit_underline"></q9-icon-button>

        <q9-icon-button
          *ngIf="listFormatEnabled"
          (click)="handleToggleUnorderedList()"
          icon="action_icons:edit_list"></q9-icon-button>

        <q9-icon-button
          *ngIf="listFormatEnabled"
          (click)="handleToggleOrderedList()"
          icon="action_icons:edit_list_numbered"></q9-icon-button>

        <ng-container *ngIf="controlsMode >= 2">
          <q9-icon-button
            [ngClass]="{enabled: styleObj.textAlign === 'left'}"
            (click)="handleSwitchFont('textAlign', 'left')"
            icon="action_icons:edit_align_left"></q9-icon-button>

          <q9-icon-button
            [ngClass]="{enabled: styleObj.textAlign === 'center'}"
            (click)="handleSwitchFont('textAlign', 'center')"
            icon="action_icons:edit_align_center"></q9-icon-button>

          <q9-icon-button
            [ngClass]="{enabled: styleObj.textAlign === 'right'}"
            (click)="handleSwitchFont('textAlign', 'right')"
            icon="action_icons:edit_align_right"></q9-icon-button>
        </ng-container>

        <ng-container *ngIf="controlsMode === 3">
          <q9-icon-button
            [ngClass]="{enabled: styleObj.verticalAlign === 'top'}"
            (click)="handleSwitchFont('verticalAlign', 'top')"
            icon="action_icons:vertical_align_top"></q9-icon-button>

          <q9-icon-button
            [ngClass]="{enabled: styleObj.verticalAlign === 'middle'}"
            (click)="handleSwitchFont('verticalAlign', 'middle')"
            icon="action_icons:vertical_align_center"></q9-icon-button>

          <q9-icon-button
            [ngClass]="{enabled: styleObj.verticalAlign === 'bottom'}"
            (click)="handleSwitchFont('verticalAlign', 'bottom')"
            icon="action_icons:vertical_align_bottom"></q9-icon-button>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
